import { render, staticRenderFns } from "./EditGrid.vue?vue&type=template&id=80b866fc&scoped=true&"
import script from "./EditGrid.vue?vue&type=script&lang=js&"
export * from "./EditGrid.vue?vue&type=script&lang=js&"
import style0 from "./EditGrid.vue?vue&type=style&index=0&id=80b866fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b866fc",
  null
  
)

export default component.exports